/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        videoContainer: {
            position: 'relative',
            width: '100%',
            height: {base: 'calc(100vh - 50px)', lg: 'calc(100vh - 111px)'},
            overflow: 'hidden'
        },
        darkenedBg: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0',
            bgGradient: 'linear(to-t, blackAlpha.700, transparent)'
        },
        overlayContainer: {
            maxWidth: 'container.xxxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '100%',
            height: '100vh',
            paddingX: 4,
            position: 'absolute',
            left: '50%',
            top: '0',
            transform: 'translateX(-50%)',
            flexDirection: 'column',
            alignItems: props.overlayAlignmentX === 'left' ? 'flex-start' : 'center',
            justifyContent:
                props.overlayAlignmentY === 'top'
                    ? 'flex-start'
                    : props.overlayAlignmentY === 'bottom'
                      ? 'flex-end'
                      : 'center',

            color: props.textColor,
            paddingBottom:
                props.overlayAlignmentY === 'bottom' ? {base: '7%', lg: '12%', xl: '4%'} : 0,
            paddingTop: props.overlayAlignmentY === 'top' ? '7%' : 0
        }
    }),
    variants: {},
    parts: ['videoContainer', 'darkenedBg', 'overlayContainer']
}
